// extracted by mini-css-extract-plugin
module.exports = {"logo":"Logo_logo__3QUlN","dark":"Logo_dark__2BGAl","light":"Logo_light__2QjZf"};